import { Injectable } from "@angular/core"
import { catchError, tap } from "rxjs/operators"
import { LmApiService } from "./lm-api.service"
import { NotificationsService } from "angular2-notifications"
import Utils from "../utils/utils"
import { HttpErrorResponse } from "@angular/common/http"
import { throwError } from "rxjs"
import { CustomNotificationsService } from "./custom-notifications.service"

@Injectable()
export class FoldersService {
    constructor(
        private lmApiService: LmApiService,
        private customNotificationsService: CustomNotificationsService,
        private notificationService: NotificationsService
    ) {}

    //FIXME this could be deleted after the Favorites and Folders new implementations are fully rolled out
    public createNewFolder(name: string, parent: number) {
        const formData = new FormData()
        formData.append("name", name)
        formData.append("description", "")
        formData.append("parent", parent.toString())
        return this.lmApiService
            .post("/new_folder/", formData)
            .pipe(catchError((error) => this.lmApiService.handleErrorForNonCritical(error)))
    }

    public addToFolder(itemId: number, folderId: number[]) {
        const data = { folder_items: folderId, activity: itemId }
        return this.lmApiService
            .post("api/v2/tools/folders/add-activity/", JSON.stringify(data), {
                headers: { "Content-Type": "application/json" },
            })
            .pipe(
                tap(() =>
                    this.notificationService.success(
                        "Assignment added",
                        "Assignment was successfully added to the selected folder(s).",
                        Utils.alertConfiguration
                    )
                ),
                catchError((errorResponse: HttpErrorResponse) => {
                    this.customNotificationsService.handleServerError(
                        errorResponse,
                        "Add to folder failed",
                        "Could not assign item to folder."
                    )

                    return throwError(() => errorResponse)
                })
            )
    }

    public removeFromFolder(folderId: number, keyName: string, itemId: number) {
        const data = { folder_pk: folderId, [keyName]: [itemId] }
        return this.lmApiService
            .post("/remove_from_folder/", JSON.stringify(data))
            .pipe(catchError((error) => this.lmApiService.handleErrorForNonCritical(error)))
    }
}
